import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import FeaturedComics from './components/FeaturedComics';
import HotComics from './components/HotComics';
import LatestUpdates from './components/LatestUpdates';
import CategoryPreview from './components/CategoryPreview';
import FAQ from './components/FAQ';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫网 - 漫画免费韩漫',
    url: 'https://www.hanman-site.com/',
    description: '韩漫网站专业提供海量漫画免费韩漫，支持下拉式韩漫在线阅读，涵盖丰富的阅读漫画大全资源，让你随时随地畅享高清流畅的阅读体验，无需注册，直接畅读热门佳作！',
    inLanguage: 'zh-Hans',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.hanman-site.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫网',
    url: 'https://www.hanman-site.com/',
    description: '专业韩漫在线阅读平台',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩漫网站是否需要注册才能阅读？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要！韩漫网站始终坚持免费开放的原则，所有漫画资源均可直接在线阅读，无需注册账号，无需任何付费。',
        },
      },
      {
        '@type': 'Question',
        name: '什么是下拉式韩漫在线阅读？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '下拉式韩漫在线阅读是一种专为手机和网页优化的阅读方式。您只需向下滑动页面，漫画内容就会连续不断地呈现。',
        },
      },
      {
        '@type': 'Question',
        name: '网站上的韩漫资源多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们每天都会更新漫画资源，热门连载作品保持与韩国同步更新。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <Navbar />
      <main>
        <Hero />
        <FeaturedComics />
        <HotComics />
        <CategoryPreview />
        <LatestUpdates />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}